import AlexaI18nService from 'src/modules/alexaI18n/alexaI18nService';
import Errors from 'src/modules/shared/error/errors';
import { getHistory } from 'src/modules/store';

const prefix = 'ALEXAI18N_VIEW';

const alexaI18nViewActions = {
  FIND_STARTED: `${prefix}_FIND_STARTED`,
  FIND_SUCCESS: `${prefix}_FIND_SUCCESS`,
  FIND_ERROR: `${prefix}_FIND_ERROR`,

  doFind: (id) => async (dispatch) => {
    try {
      dispatch({
        type: alexaI18nViewActions.FIND_STARTED,
      });

      const record = await AlexaI18nService.find(id);

      dispatch({
        type: alexaI18nViewActions.FIND_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: alexaI18nViewActions.FIND_ERROR,
      });

      getHistory().push('/alexa-i18n');
    }
  },
};

export default alexaI18nViewActions;
